module.exports = __webpack_public_path__ + "img/dominant2.7ce42faa.png";